import api from './Api';
import { adminPasswordConfig } from './AdminConfirmation';
export const submitFeedback = (message, roomId, name = '', email = '') => api.post('/api/feedback', { message, name, email }, roomId ? { _roomId: roomId } : undefined);
export const getFeedback = (page = 1, status = '') => api.get('/api/feedback', { params: { page, ...(status ? {status} : {}) } }).then(response => response.data);
export const updateFeedbackStatus = (id, status, password) => api.patch(`/api/feedback/${id}/status`, {status}, adminPasswordConfig(password));
